import api from "../../../utils/helpers/api";

const getNewsDetail = (params) => {
  return api({ method: "get", url: `news/${params}`, params });
};

export const newServices = {
  getNewsDetail
};
